module.exports = __webpack_public_path__ + "media/images/oficinas/goya-751db8c723c978ee18ee6bc4204c0b55.jpg";